import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { graphql } from 'react-apollo'
import { withStyles } from 'material-ui/styles'
import { Button, TextField, Typography, CircularProgress } from 'material-ui'
import { Email, VpnKey } from 'material-ui-icons'
import isEmail from 'validator/lib/isEmail'
import { AUTHENTICATE_USER } from '@/graphql/mutations/user'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import {
  GC_USER_ID,
  GC_AUTH_TOKEN,
  ALABASTER,
  BOULDER,
  KOROMIKO,
  SHAKESPEARE
} from '@/constants'

import { READ_USERNAME } from '@/graphql/queries/user'

const styles = theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: '100vh'
  },
  rootInner: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    borderStyle: 'solid',
    borderColor: BOULDER,
    borderWidth: 0,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  leftGrid: {
    backgroundColor: ALABASTER,
    width: '80%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '10%'
  },
  rightGrid: {
    backgroundImage: 'url(notebook.png)',
    backgroundSize: 'cover',
    height: '100%',
    flexGrow: 1
  },
  leftSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    paddingLeft: 30,
    paddingRight: 30,
    marginBottom: 15
  },
  errorContainer: {
    fontSize: 12,
    color: KOROMIKO,
    marginBottom: 30
  },
  btnContainer: {
    textAlign: 'center',
    paddingLeft: 30,
    paddingRight: 30
  },
  txtContainer: {
    textAlign: 'center',
    paddingLeft: 60,
    paddingRight: 60
  },
  txtContainerLoggedinAs: {
    position: 'relative',
    textAlign: 'center',
    paddingLeft: 60,
    paddingRight: 60,
    top: -100
  },
  btnContainerLoggedinAs: {
    position: 'relative',
    textAlign: 'right',
    paddingLeft: 60,
    paddingRight: 5
  },
  text: {
    fontSize: 14,
    color: 'grey'
  },
  loginButton: {
    width: '65%',
    backgroundColor: 'rgba(80, 227, 194, .7)',
    color: 'white',
    fontSize: 15
  },
  forgotPasswordButton: {
    width: 160,
    backgroundColor: ALABASTER,
    fontSize: 13,
    color: SHAKESPEARE
  },
  icon: {
    width: 40,
    marginRight: 10,
    color: 'lightgrey'
  },
  textField: {
    backgroundColor: 'white',
    flexGrow: 1
  },
  backBtn: {
    position: 'absolute',
    textAlign: 'left',
    left: 8,
    top: 8
  },
  progress: {
    margin: theme.spacing.unit * 2,
    color: 'lightgrey'
  }
})

@withRouter
@withStyles(styles)
@graphql(AUTHENTICATE_USER, { name: 'authenticateUser' })
@graphql(READ_USERNAME, {
  name: 'ReadUserName',
  options: ({ match }) => ({
    variables: {
      userID: global.localStorage.getItem(GC_USER_ID)
        ? global.localStorage.getItem(GC_USER_ID)
        : 'NA'
    }
  })
})
export default class Login extends Component {
  state = {
    email: '',
    password: '',
    errors: [],
    loader: false
  }

  updateField = evt => {
    this.setState({ loader: false })
    const { name, value } = evt.currentTarget
    this.setState({ [name]: value })
  }

  addError = msg => {
    this.setState(prevState => ({
      errors: [...prevState.errors, msg]
    }))
  }

  isValid = () => {
    const { email, password } = this.state

    if (!email.length || !password.length) {
      this.setState({ loader: false })
      this.addError('All fields are required.')
      return false
    }

    if (!isEmail(email)) {
      this.setState({ loader: false })
      this.addError('Invalid email address.')
      return false
    }

    return true
  }

  forgotPassword = evt => {
    console.log('forgot password is NYI')
  }

  login = evt => {
    this.setState({
      loader: true
    })
    evt.preventDefault()
    this.setState({ errors: [] }, async () => {
      if (this.isValid()) {
        const { email, password } = this.state
        try {
          const result = await this.props.authenticateUser({
            variables: {
              email,
              password
            }
          })

          const { id, token } = result.data.authenticateUser
          // todo - decouple/use cookies
          global.localStorage.setItem(GC_USER_ID, id)
          global.localStorage.setItem(GC_AUTH_TOKEN, token)
          // redirect to homepage
          this.props.history.push(`/`)
        } catch (e) {
          this.setState({ loader: false })
          console.log(e)
          this.addError(
            e.toString().includes('Wrong Password!')
              ? 'Wrong Password!'
              : e.toString().includes('Email not found!')
                ? 'Email not found!'
                : 'Invalid credentials, please try again!'
          )
        }
      }
    })
  }

  signOut = () => {
    global.localStorage.removeItem(GC_USER_ID)
    global.localStorage.removeItem(GC_AUTH_TOKEN)
    this.props.history.push(`/login`)
  }

  handleClose = () => {
    this.props.history.push(`/`)
  }

  handleCloseBack = () => {
    this.props.history.goBack()
  }

  render() {
    const { classes } = this.props
    const { errors } = this.state
    const userId = global.localStorage.getItem(GC_USER_ID)

    // get user name
    if (userId) {
      if (this.props.ReadUserName && this.props.ReadUserName.loading) {
        return <div>Loading</div>
      }

      if (this.props.ReadUserName && this.props.ReadUserName.error) {
        return <div>Error: {this.props.ReadUserName.error}</div>
      }
    }

    return (
      <div className={classes.root}>
        <div className={classes.rootInner}>
          <div className={classes.leftGrid}>
            <div className={classes.leftSubContainer}>
              <div
                style={{
                  width: '100%',
                  position: 'absolute',
                  left: 0,
                  top: 100
                }}
              >
                <img
                  src={process.env.PUBLIC_URL + '/alchemy_title.png'}
                  alt="title"
                />
              </div>
              {userId ? (
                <div>
                  <div className={classes.txtContainerLoggedinAs}>
                    <Typography className={classes.text} variant="body1">
                      You are logged in as {this.props.ReadUserName.User.name}.<br />{' '}
                      <Link to={`/start`} onClick={this.signOut}>
                        Log Out?
                      </Link>
                    </Typography>
                  </div>
                  <div className={classes.btnContainerLoggedinAs}>
                    <Button color="inherit" onClick={this.handleClose}>
                      <Typography
                        variant="body1"
                        style={{ fontSize: 18, color: 'grey' }}
                      >
                        Continue
                      </Typography>
                      <ChevronRightIcon style={{ color: 'grey' }} />
                    </Button>
                  </div>
                </div>
              ) : (
                <div>
                  {errors && (
                    <div className={classes.errorContainer}>
                      {errors.map((error, key) => <div key={key}>{error}</div>)}
                    </div>
                  )}
                  <div className={classes.inputContainer}>
                    <Email className={classes.icon} />
                    <TextField
                      className={classes.textField}
                      label="Email"
                      name="email"
                      onChange={this.updateField}
                    />
                  </div>
                  <div className={classes.inputContainer}>
                    <VpnKey className={classes.icon} />
                    <TextField
                      type="password"
                      className={classes.textField}
                      label="Password"
                      name="password"
                      onChange={this.updateField}
                    />
                  </div>
                  <div className={classes.btnContainer}>
                    <Button
                      className={classes.forgotPasswordButton}
                      onClick={this.forgotPassword}
                    >
                      Forgot Password
                    </Button>
                    {this.state.loader ? (
                      <div>
                        <CircularProgress
                          className={classes.progress}
                          size={40}
                        />
                      </div>
                    ) : (
                      <Button
                        className={classes.loginButton}
                        onClick={this.login}
                      >
                        Login
                      </Button>
                    )}
                  </div>
                  <div className={classes.txtContainer}>
                    <Typography className={classes.text} variant="body1">
                      New to Alchemy?{' '}
                      <Link to={`/register`}>Sign up here.</Link>
                    </Typography>
                  </div>
                  <div className={classes.txtContainer}>
                    <Typography className={classes.text} variant="body1">
                      By continuing, you agree to our{' '}
                      <Link to={`/login`}>Privacy Policy</Link>
                    </Typography>
                  </div>
                  <div className={classes.backBtn}>
                    <Button color="inherit" onClick={this.handleCloseBack}>
                      <ChevronLeftIcon style={{ color: 'grey' }} />
                      <Typography
                        variant="body1"
                        style={{ fontSize: 15, color: 'grey' }}
                      >
                        Back
                      </Typography>
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/login/index.js